// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3UlwG","title":"ClientCherryInfo_title__4i47q","itemText":"ClientCherryInfo_itemText__nkd7L"};